import api from './api'

export interface AppNotification {
  id: string
  userId: string | null
  type: string
  title: string
  message: string
  severity: 'info' | 'warning' | 'error' | 'success'
  meta: string | null
  isRead: boolean
  createdAt: string
}

export const notificationsService = {
  async getAll(unread = false): Promise<AppNotification[]> {
    const res = await api.get('/notifications', { params: { unread: unread ? 'true' : undefined } })
    return res.data
  },

  async getCount(): Promise<number> {
    const res = await api.get('/notifications/count')
    return res.data.count ?? 0
  },

  async markRead(id: string): Promise<void> {
    await api.patch(`/notifications/${id}/read`)
  },

  async markAllRead(): Promise<void> {
    await api.patch('/notifications/read-all')
  },
}
